import { AutoMap } from '@automapper/classes';

export class TaskEntity {
    Id?: number;
    @AutoMap()
    Position!: number;
    @AutoMap()
    Description!: string;
    @AutoMap()
    StartedOn!: string;
    @AutoMap()
    EndedOn!: string;
    @AutoMap()
    Posture!: number;
    @AutoMap()
    Repetitif!: boolean;
}
